"use client";

import { useEffect } from "react";

/**
 * The reviews header renders in its on-dark treatment (champagne logo + light
 * nav) BY DEFAULT via CSS (`body:has(.reviews-intro-panel):not(.reviews-scrolled)`
 * in reviews.css), so it's already light at first paint — no mocha→light flash.
 * This only marks the body `reviews-scrolled` once the user scrolls past the
 * hero, which drops the on-dark rules and lets the header fall back to its
 * scrolled (mocha) chrome, in sync with HeaderBackground's opaque bar.
 */
const ReviewsHeaderTheme = () => {
  useEffect(() => {
    const sync = () => {
      document.body.classList.toggle("reviews-scrolled", window.scrollY > 1);
    };

    sync();
    window.addEventListener("scroll", sync, { passive: true });

    return () => {
      window.removeEventListener("scroll", sync);
      document.body.classList.remove("reviews-scrolled");
    };
  }, []);

  return null;
};

export default ReviewsHeaderTheme;
